import React  from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faBuilding } from '@fortawesome/free-solid-svg-icons';
import  { useState,useEffect,useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Slider from "rc-slider";
import './filter.css';
import { Link, NavLink } from "react-router-dom";
const Commercial = () => {
	let publicUrl = process.env.PUBLIC_URL+'/'
	let imagealt = 'image'
  const [products, setProducts] = useState([]);
		const navigate = useNavigate(); // Hook pour naviguer
    const [priceRange, setPriceRange] = useState([10000, 5000000]); // Plage initiale
	const propertiesPerPage = 250;
  const [minLotSize, setMinLotSize] = useState("");
const [maxLotSize, setMaxLotSize] = useState("");
const [minDate, setMinDate] = useState("");
const [selectedTransactionType, setSelectedTransactionType] = useState('rent'); // Valeur initiale à 'rent'

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedPriceRange, setSelectedPriceRange] = useState(null); // Plage de prix appliquée
  const [selectedTags, setSelectedTags] = useState([]); // Liste des tags sélectionnés
  const [selectedAddress, setSelectedAddress] = useState(""); 
		const [currentPage, setCurrentPage] = useState(1);
		const [totalProperties, setTotalProperties] = useState(60992);
		const [activeTab, setActiveTab] = useState('galerie');
		const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [isPriceFilterOpen, setIsPriceFilterOpen] = useState(false); // État pour ouvrir/fermer la carte
  const [loading, setLoading] = useState(false);
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);

  const [isCoduSelected, setIsCoduSelected] = useState(false);

  useEffect(() => {
    if (query.trim().length < 2) {
      setSuggestions([]);
      return;
    }
  
    const fetchSuggestions = async () => {
      try {
        const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/search-predictive", {
          params: { query },
        });
        setSuggestions(response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération des suggestions :", error);
      }
    };
  
    fetchSuggestions();
  }, [query]);
  
  
  

  const handleRemoveTag = (tagToRemove) => {
    setSelectedTags(selectedTags.filter((tag) => tag !== tagToRemove));
  };
  
  
	// Effet pour récupérer les produits depuis le backend
	useEffect(() => {
	  // Fonction pour récupérer les produits
	  const fetchProducts = async () => {
		try {
		  const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products');  // URL de votre backend
		  setProducts(response.data);  // Met à jour l'état avec les produits récupérés
		} catch (error) {
		  console.error('Erreur lors de la récupération des produits:', error);
		}
	  };
  
	  fetchProducts();  // Appel de la fonction pour récupérer les produits
	}, []);  // Le tableau vide [] indique que l'effet s'exécute une seule fois lors du montage du composant
  
	




  const handleCardClick = (item) => {
    // Stockez l'élément sélectionné
    setSelectedAddress(item); // Par exemple, enregistre l'élément dans un état
    console.log("Adresse sélectionnée :", item);
  };
  

  
const [transactionType, setTransactionType] = useState(() => {
  const savedType = localStorage.getItem("transactionType") || "rent";
  console.log("Valeur initiale de transactionType :", savedType); // Log 1
  return savedType;
});






useEffect(() => {
  const savedType = localStorage.getItem("transactionType");
  if (savedType) {
    setTransactionType(savedType);
  }
}, []);



  
  

  // --------------------------------------------------------------
 
 

  const handleCloseFilter = () => {
    setIsPriceFilterOpen(false); // Ferme la carte des prix
  };

  // --------------------------------------------------------filter-----------
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const handleTogglePriceFilter = () => {
    setIsPriceFilterOpen(!isPriceFilterOpen);
  };

    const modalRef = useRef(null);
  
const [isPropertyTypeOpen, setIsPropertyTypeOpen] = useState(false); // État pour afficher les cases à cocher

  const handleTogglePropertyType = () => {
    setIsPropertyTypeOpen(!isPropertyTypeOpen);
  };
  const [isCharacteristicsOpen, setIsCharacteristicsOpen] = useState(false); // État pour afficher les caractéristiques

  const handleToggleCharacteristics = () => {
    setIsCharacteristicsOpen(!isCharacteristicsOpen);
  };

  const [isBuildingOpen, setIsBuildingOpen] = useState(false); // État pour afficher les détails du bâtiment
  
    const handleToggleBuilding = () => {
      setIsBuildingOpen(!isBuildingOpen);
    };

     const [isOtherCriteriaOpen, setIsOtherCriteriaOpen] = useState(false); // État pour afficher les autres critères
     const [properties, setProperties] = useState([]);

      const handleToggleOtherCriteria = () => {
        setIsOtherCriteriaOpen(!isOtherCriteriaOpen);
      };
      useEffect(() => {
        const fetchProperties = async () => {
          try {
            const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/products", {
              params: { transactionType: "À vendre" },
            });
            setProperties(response.data);
          } catch (error) {
            console.error("Erreur lors de la récupération des propriétés :", error);
          }
        };
      
        fetchProperties();
      }, []);
      
    
      const handleTransactionChange = (e) => {
        setTransactionType(e.target.value);
      };
    
      // Application du filtre de prix
      const handleApplyFilter = () => {
        setSelectedPriceRange(priceRange); // Appliquer la plage sélectionnée
        setIsPriceFilterOpen(false); // Fermer le filtre
      };
    
      // Redirection vers la page de recherche
    
      useEffect(() => {
        const fetchProperties = async () => {
          try {
            const params = {
              transactionType: transactionType,
              minPrice: selectedPriceRange ? selectedPriceRange[0] : undefined,
              maxPrice: selectedPriceRange ? selectedPriceRange[1] : undefined,
            };
      
            if (selectedAddress && selectedAddress.trim() !== "") {
              params.address = selectedAddress;
            }
      
            const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/api/filtre", {
              params: params,
            });
            setProperties(response.data);
          } catch (error) {
            console.error("Erreur lors de la récupération des propriétés :", error);
          }
        };
      
        fetchProperties();
      }, [transactionType, selectedAddress, selectedPriceRange]);
      
  // Redirection avec les filtres appliqués

  
  useEffect(() => {
    console.log("Adresse sélectionnée pour le filtrage :", selectedAddress);
  }, [selectedAddress]);
  
  

  const handleSuggestionClick = (suggestion) => {
    console.log("Suggestion sélectionnée :", suggestion);
    setSelectedAddress(suggestion); // Met à jour l'adresse sélectionnée
    console.log("Adresse sélectionnée après mise à jour :", selectedAddress); // Ajoutez ce log
    setQuery(""); // Réinitialise la barre de recherche
    setSuggestions([]); // Vide les suggestions
  };
  
  

  // Gestion de la suppression d'une adresse
  const handleRemoveAddress = () => {
    setSelectedAddress("");
  };
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState("rent"); // Valeur par défaut
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // const handleOptionSelect = (option) => {
  //   console.log("Option sélectionnée :", option); // Debugging
  //   setSelectedTransaction(option);
  //   setIsDropdownOpen(false);

  //   // Redirection selon l'option sélectionnée
  //   if (option === "sale") {
  //     console.log("Redirection vers /vendre"); // Debugging
  //     navigate("/vendre");
  //   } else if (option === "rent") {
  //     console.log("Redirection vers /louer"); // Debugging
  //     navigate("/louer");
  //   }
  // };

  const handleOptionSelect = (option) => {
    setSelectedTransaction(option); // Met à jour uniquement la transaction sélectionnée
    setIsDropdownOpen(false); // Ferme le menu dropdown
  };


  // ----------------------------------filtre------------------
  const handleFilterChange = (type) => {
    setSelectedPropertyTypes((prevTypes) =>
      prevTypes.includes(type)
        ? prevTypes.filter((t) => t !== type) // Retire le type si déjà sélectionné
        : [...prevTypes, type] // Ajoute le type s'il n'est pas déjà sélectionné
    );
  };
  

 
  const [selectedCharacteristics, setSelectedCharacteristics] = useState([]);
  
  
  const handleCharacteristicsChange = (event) => {
    const value = event.target.value;
    setSelectedCharacteristics((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };
  const [selectedStructureTypes, setSelectedStructureTypes] = useState([]); // 🔥 Déclaration ici

  const handlePropertyTypeChange = (type) => {
    setSelectedPropertyTypes((prevTypes) =>
      prevTypes.includes(type)
        ? prevTypes.filter((t) => t !== type)
        : [...prevTypes, type]
    );
  };
  const handleStructureTypeChange = (event) => {
    const value = event.target.value;
    setSelectedStructureTypes((prev) =>
      prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
    );
  };

  const handleSearch = () => {
    let searchTerms = [];
  
    if (selectedPropertyTypes.length > 0) {
      searchTerms.push(`types=${selectedPropertyTypes.join(",")}`);
    }
  
    if (selectedStructureTypes.length > 0) {
      searchTerms.push(`structureTypes=${selectedStructureTypes.join(",")}`);
    }
  
    // Si aucun filtre n'est appliqué, passer "all"
    const searchQuery = searchTerms.length > 0 ? searchTerms.join("&") : "all";
  
    // Encoder pour éviter les erreurs d'URL
    const targetUrl = `/resultss/${encodeURIComponent(searchQuery)}`;
  
    console.log("🔍 Naviguer vers :", targetUrl);
    navigate(targetUrl);
  };
  
  
  const handleSearch1 = () => {
    let searchTerms = [];
  
    // 🔹 Superficie du terrain
    if (minLotSize) {
      searchTerms.push(`minLotSize=${minLotSize}`);
    }
    if (maxLotSize) {
      searchTerms.push(`maxLotSize=${maxLotSize}`);
    }
  
    // 🔹 Date d'ajout
    if (minDate) {
      searchTerms.push(`minDate=${minDate}`);
    }
  
    // 🔥 Si aucun critère avancé n'est sélectionné, passer "all"
    const searchQuery = searchTerms.length > 0 ? searchTerms.join("&") : "all";
  
    // 🔹 Encoder l'URL et naviguer vers `ResultsPage`
    const targetUrl = `/results/${encodeURIComponent(searchQuery)}`;
  
    console.log("🔍 URL générée :", targetUrl);
    navigate(targetUrl);
  };
  
  
  const handleToggleFilterModal = () => {
      setIsFilterModalOpen((prev) => !prev);
    };
  
    // Ferme le modal lorsqu'on clique en dehors
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          setIsFilterModalOpen(false);
        }
      };
  
      if (isFilterModalOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isFilterModalOpen]);
    const handleResetFilters = () => {
      setSelectedPropertyTypes([]);
      setSelectedStructureTypes([]);
      setMinLotSize("");
      setMaxLotSize("");
      setMinDate("");
    };
    
    const cardRef = useRef(null); // Référence pour détecter les clics

    // Fonction pour détecter un clic en dehors de la carte
    useEffect(() => {
      function handleClickOutside(event) {
        if (cardRef.current && !cardRef.current.contains(event.target)) {
          setIsPriceFilterOpen(false); // Ferme la carte
        }
      }
  
      // Ajouter l'écouteur de clic lorsqu'on ouvre le filtre
      if (isPriceFilterOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isPriceFilterOpen]);
    const handleTransactionTypeChange = (transactionType) => {
      setSelectedTransactionType(transactionType);
  
      // Fermer le menu déroulant après une sélection
      setIsDropdownOpen(false);
  
      // Si "sale" est sélectionné, définis la valeur initiale à 100 000 000 (extrême droite)
      if (transactionType === "sale") {
        setPriceRange([0, 100000000]);
      } else if (transactionType === "rent") {
        setPriceRange([10000, 5000000]);
      } else {
        // Si "buy" est sélectionné (au cas où), tu peux définir un comportement spécifique
        setPriceRange([10000, 100000000]);  // Par exemple, une plage plus large pour l'achat
      }
    };
  
     const [isHovered, setIsHovered] = useState(false);
  
    const buttonStyle = {
      backgroundColor: "white",  // Fond transparent
      color: "black",  // Hérite de la couleur du texte
      border: "none",  // Pas de bordure
      cursor: "pointer",  // Curseur de type main
      outline: "none",  // Enlève l'outline bleu
      transition: "background-color 0.3s ease",  // Transition pour une interaction plus fluide
    };
  
    const hoverStyle = {
      backgroundColor: "white",  // Fond transparent au survol
    };

    const handleSearchClick = () => {
      // Créer un objet `filters` pour stocker les critères de recherche
      const filters = {
        address: selectedAddress || null,
        priceRange: selectedPriceRange || null,
        transactionType: selectedTransactionType,
      };
  
      // Validation pour s'assurer qu'un type de transaction est sélectionné
      if (!filters.transactionType) {
        alert("Veuillez sélectionner un type de transaction avant de rechercher.");
        return;
      }
  
      // Déterminer la route de redirection en fonction du type de transaction
      const targetPath = filters.transactionType === "sale" ? "/vendre" : "/louer";
  
      // Redirection vers la route cible avec les filtres passés dans l'état
      navigate(targetPath, { state: filters });
    };
  return (
    <div
    className="hero-section"
    style={{
      backgroundImage: `url(${publicUrl}assets/img/gallery/frontkeurgui.png)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '50vh',
    }}
  >
    <div className="overlay">
      <h1 style={{ color: "white", textAlign: "center" }}>
        D&eacute;couvrez l&apos;ensemble des
      </h1>
      <h1 style={{ color: "white", textAlign: "center" }}>
        propri&eacute;t&eacute;s disponibles
      </h1>
  
      <br />
      <div className="tabs">
        <NavLink
          to="/"
          className={({ isActive }) => (isActive ? "tab active" : "tab")}
        >
          <FontAwesomeIcon icon={faHome} />
          {"R\u00e9sidentiel"}
        </NavLink>
        <NavLink
          to="/home"
          className={({ isActive }) => (isActive ? "tab active" : "tab")}
        >
          <FontAwesomeIcon icon={faBuilding} />
          Commercial
        </NavLink>
      </div>
  
      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder={"Chercher par ville, quartier, région ou adresse"}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{
            border: "2px solid white",
            height: "50px",
          }}
        />
  
        <div className="search-fields">
        
  
          {/* Dropdown for transaction type */}
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <button
              className="filter"
              onClick={toggleDropdown}
              style={{
                height: "50px",
                backgroundColor: "white",
                border: "1px solid #ccc",
                cursor: "pointer",
                padding: "0 15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "nowrap",
                borderRadius: "0",
              }}
            >
              {selectedTransactionType === "rent"
                ? "À louer"
                : selectedTransactionType === "sale"
                ? "À vendre"
                : "À acheter"}{" "}
              {"▼"}
            </button>
  
            {/* Dropdown Options */}
            {isDropdownOpen && (
              <ul
                className="dropdown-options"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  color: "black",
                  backgroundColor: "white",
                  width: "100%",
                  maxWidth: "200px",
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  listStyle: "none",
                  padding: "5px 0",
                  margin: 0,
                  zIndex: 1000,
                }}
              >
                <li
                  onClick={() => handleTransactionTypeChange("rent")}
                  style={{
                    padding: "8px 15px",
                    cursor: "pointer",
                    backgroundColor:
                      selectedTransactionType === "rent" ? "#f4f4f4" : "white",
                    fontSize: "14px",
                  }}
                >
                  À louer
                </li>
                <li
                  onClick={() => handleTransactionTypeChange("sale")}
                  style={{
                    padding: "8px 15px",
                    cursor: "pointer",
                    backgroundColor:
                      selectedTransactionType === "sale" ? "#f4f4f4" : "white",
                    fontSize: "14px",
                  }}
                >
                  À vendre
                </li>
              </ul>
            )}
          </div>
  
          {/* Price Filter Button */}
          <button
            className="filter"
            onClick={() => setIsPriceFilterOpen(!isPriceFilterOpen)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={isHovered ? { ...buttonStyle, ...hoverStyle } : buttonStyle}
          >
            Prix
          </button>
  
          {/* Price Filter Card */}
          {isPriceFilterOpen && (
            <div ref={cardRef} className="price-filter-card">
              <h4>Prix</h4>
  
              {/* Slider based on selection */}
              {selectedTransactionType === "rent" ? (
                <Slider
                  range
                  min={10000}
                  max={5000000}
                  step={50000}
                  value={priceRange}
                  onChange={(value) => setPriceRange(value)}
                  allowCross={false}
                />
              ) : selectedTransactionType === "sale" ? (
                <Slider
                  range
                  value={priceRange}
                  min={0}
                  max={100000000}
                  step={1000000}
                  onChange={(value) => setPriceRange(value)}
                />
              ) : (
                <Slider
                  range
                  value={priceRange}
                  min={10000}
                  max={100000000}
                  step={5000000}
                  onChange={(value) => setPriceRange(value)}
                />
              )}
  
              <div className="price-inputs">
                <div className="price-input">
                  <span>{priceRange[0].toLocaleString()}</span>
                </div>
                <div className="price-input">
                  <span>{priceRange[1].toLocaleString()} +</span>
                </div>
              </div>
  
              <div className="filter-buttons">
                <button
                  className="close-button"
                  onClick={() => setIsPriceFilterOpen(false)}
                >
                  Fermer
                </button>
                <button
                  className="apply-button1"
                  onClick={handleApplyFilter}
                  style={{
                    backgroundColor: "#975D23",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#7a4811")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "#975D23")
                  }
                >
                  Appliquer
                </button>
              </div>
            </div>
          )}
  
          {/* Applied Price Tag */}
          {selectedPriceRange && (
            <div className="selected-price-tag">
              <span>
                Prix max. {selectedPriceRange[1].toLocaleString()} FCFA
              </span>
              <button
                className="clear-price-button"
                onClick={() => setSelectedPriceRange(null)}
              >
                ✕
              </button>
            </div>
          )}
  
          {/* Filter Modal Button */}
          <button
            className="filter-button"
            style={{ backgroundColor: "#d3d3d3", color: "black" }}
            onClick={handleToggleFilterModal}
          >
            Filtres
          </button>
  
          {/* Filter Modal */}
          {isFilterModalOpen && (
            <div className="filter-modal" ref={modalRef}>
              <div className="filter-options">
                {/* Property Type */}
                <div className="filter-item">
                  <div className="filter-item-header">
                    <span className="filter-item-title">Type d'habitat</span>
                    <button
                      className="expand-button"
                      onClick={() => setIsPropertyTypeOpen(!isPropertyTypeOpen)}
                    >
                      {isPropertyTypeOpen ? "-" : "+"}
                    </button>
                  </div>
                  {isPropertyTypeOpen && (
                    <div className="checkbox-group">
                      <div>
                        <label>
                          <input
                            type="checkbox"
                            value="appartement"
                            onChange={() =>
                              handlePropertyTypeChange("appartement")
                            }
                            checked={selectedPropertyTypes.includes("appartement")}
                          />
                          Appartement
                        </label>
                        <label style={{ marginTop: "10px", marginLeft: "-2px" }}>
                          <input
                            type="checkbox"
                            onChange={() =>
                              handleFilterChange("bureau_commerce")
                            }
                            checked={selectedPropertyTypes.includes(
                              "bureau_commerce"
                            )}
                          />
                          Bureau / Commerce
                        </label>
                        <label style={{ marginTop: "10px", marginLeft: "6px" }}>
                          <input
                            type="checkbox"
                            onChange={() =>
                              handleFilterChange("hotel_restaurant")
                            }
                            checked={selectedPropertyTypes.includes(
                              "hotel_restaurant"
                            )}
                          />
                          Hôtel / Restaurant
                        </label>
                      </div>
                      <div>
                        <label>
                          <input
                            type="checkbox"
                            style={{ marginTop: "-25px", marginLeft: "-4px" }}
                            onChange={() =>
                              handleFilterChange("studio_chambre")
                            }
                            checked={selectedPropertyTypes.includes(
                              "studio_chambre"
                            )}
                          />
                          Studio / Chambre
                        </label>
                        <label style={{ marginTop: "-15px", marginLeft: "-2px" }}>
                          <input
                            type="checkbox"
                            onChange={() =>
                              handleFilterChange("villa_maison")
                            }
                            checked={selectedPropertyTypes.includes("villa_maison")}
                          />
                          Villa / Maison
                        </label>
                        <label style={{ marginTop: "20px", marginLeft: "-2px" }}>
                          <input
                            type="checkbox"
                            style={{ marginTop: "10px" }}
                            onChange={() => handleFilterChange("terrain")}
                            checked={selectedPropertyTypes.includes("terrain")}
                          />
                          Terrain
                        </label>
                      </div>
                    </div>
                  )}
                </div>
  
                {/* Characteristics */}
                <div className="filter-item">
                  <div className="filter-item-header">
                    <span className="filter-item-title">Caractéristiques</span>
                    <button
                      className="expand-button"
                      onClick={() =>
                        setIsCharacteristicsOpen(!isCharacteristicsOpen)
                      }
                    >
                      {isCharacteristicsOpen ? "-" : "+"}
                    </button>
                  </div>
                  {isCharacteristicsOpen && (
                    <div className="checkbox-group">
                      <div>
                        <label>
                          <input
                            type="checkbox"
                            style={{ marginTop: "-10px", marginLeft: "-5px" }}
                            value="Bord de l'eau"
                            checked={selectedStructureTypes.includes(
                              "Bord de l'eau"
                            )}
                            onChange={handleStructureTypeChange}
                          />
                          Bord de l'eau
                        </label>
                        <label style={{ marginTop: "-10px", marginLeft: "10px" }}>
                          <input
                            type="checkbox"
                            value="Accès à l'eau"
                            checked={selectedStructureTypes.includes(
                              "Accès à l'eau"
                            )}
                            onChange={handleStructureTypeChange}
                          />
                          Accès à l'eau
                        </label>
                      </div>
                      <div>
                        <label style={{ marginTop: "-10px", marginLeft: "10px" }}>
                          <input
                            type="checkbox"
                            value="Plan d'eau navigable"
                            checked={selectedStructureTypes.includes(
                              "Plan d'eau navigable"
                            )}
                            onChange={handleStructureTypeChange}
                          />
                          Plan d'eau navigable
                        </label>
                        <label style={{ marginTop: "20px", marginLeft: "10px" }}>
                          <input
                            type="checkbox"
                            value="Villégiature"
                            checked={selectedStructureTypes.includes(
                              "Villégiature"
                            )}
                            onChange={handleStructureTypeChange}
                          />
                          Villégiature
                        </label>
                      </div>
                    </div>
                  )}
                </div>
  
                {/* Other Criteria */}
                <div className="filter-item">
                  <div className="filter-item-header">
                    <span className="filter-item-title">Autres Critères</span>
                    <button
                      className="expand-button"
                      onClick={() =>
                        setIsOtherCriteriaOpen(!isOtherCriteriaOpen)
                      }
                    >
                      {isOtherCriteriaOpen ? "-" : "+"}
                    </button>
                  </div>
                  {isOtherCriteriaOpen && (
                    <div className="other-criteria-content">
                      {/* Lot Size */}
                      <div className="criteria-inputs">
                        <label>
                          Superficie du terrain (m²)
                          <div className="input-group">
                            <input
                              type="number"
                              placeholder="Min (m²)"
                              value={minLotSize}
                              onChange={(e) => setMinLotSize(e.target.value)}
                              className="input-box"
                            />
                            <span>à</span>
                            <input
                              type="number"
                              placeholder="Max (m²)"
                              value={maxLotSize}
                              onChange={(e) => setMaxLotSize(e.target.value)}
                              className="input-box"
                            />
                          </div>
                        </label>
                      </div>
  
                      {/* Date Added */}
                      <div className="criteria-dates">
                        <label>
                          Nouveau depuis
                          <div className="input-group">
                            <input
                              type="date"
                              value={minDate}
                              onChange={(e) => setMinDate(e.target.value)}
                              className="input-box"
                            />
                          </div>
                        </label>
                      </div>
                      <div className="checkbox-group">
                        <label style={{ marginTop: "15px" }}>
                          <input
                            type="checkbox"
                            checked={isCoduSelected}
                            onChange={() => setIsCoduSelected(!isCoduSelected)}
                          />
                          C0d0u
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
  
              {/* Filter Actions */}
              <div className="filter-actions">
                <button
                  className="filter-button-common reset-button"
                  onClick={handleResetFilters}
                >
                  Réinitialiser
                </button>
                <button
                  className="filter-button-common close-button"
                  onClick={handleToggleFilterModal}
                >
                  Fermer
                </button>
              </div>
              <br />
              {/* Search Button */}
              <button
                className="search-btton"
                onClick={handleSearch}
                style={{
                  backgroundColor: "#975D23",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Rechercher
              </button>
            </div>
          )}
  
          {/* Search Button */}
          <button
            className="search-button"
            style={{
              backgroundColor: "black",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              width: "10px",
            }}
            onClick={handleSearchClick}
          >
            {String.fromCodePoint(0x1f50d)}
          </button>
  
          {/* Loading Indicator */}
          {loading && <progress className="progress-bar" />}
  
          {/* Search Results */}
          {query.length >= 3 && (
            <>
              {suggestions.length > 0 ? (
                <div
                  className="search-results-container"
                  style={{
                    position: "absolute", // Position absolue par rapport au parent
                    top: "66%", // Se place en dessous du parent
                    left: "455px", // Alignement horizontal
                    marginTop: "10px", // Espacement par rapport au parent
                    border: "1px solid #333",
                    borderRadius: "10px",
                    backgroundColor: "#f4f4f4",
                    padding: "5px",
                    width: "33%",
                    height:"200px",
                    overflowY: "auto",
                    // height:"50px",
                    zIndex: 1000, // Pour s'assurer qu'il apparaît au-dessus des autres éléments
                  }}
                >
                  {suggestions.map((suggestion, index) => (
                    <div
                      key={index}
                      className="result-card"
                      onClick={() => handleSuggestionClick(suggestion)}
                    >
                      <div className="result-card-content">
                        <h5>{suggestion}</h5>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="search-results-container">
                  <div className="result-card">
                    <div className="result-card-content">
                      <h5 style={{ color: "red" }}>Aucun Résultat</h5>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
  
          {/* Selected Address Tag */}
          {selectedAddress && (
            <div
              className="selected-filters"
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span
                className="selected-filter"
                style={{
                  backgroundColor: "#f4f4f4",
                  padding: "5px 10px",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {selectedAddress}
                <button
                  className="remove-tag"
                  onClick={handleRemoveAddress}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#888",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
  );
};

export default Commercial;